import React from 'react'
import { ImageView, ImageViewProps, VideoView } from '~/ui/app/media'
import { memo } from '~/ui/component'
import { Center, Spinner, VBox } from '~/ui/components'
import { colors, createUseStyles, layout } from '~/ui/styling'

export interface Props {
  file:       File
  size?:      Size
  objectFit?: ImageViewProps['objectFit']
}

const PostFormUploadingMediaThumbnail = memo('PostFormUploadingMediaThumbnail', (props: Props) => {

  const {file, size, objectFit = 'cover'} = props

  const url = React.useMemo(() => URL.createObjectURL(file), [file])
  React.useEffect(() => () => { URL.revokeObjectURL(url) }, [url])

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <VBox classNames={$.PostFormUploadingMediaThumbnail}>
        {renderMedia()}
        <Center classNames={$.spinner}>
          <Spinner size={12}/>
        </Center>
      </VBox>
    )
  }

  function renderMedia() {
    if (/^image\//.test(file.type)) {
      return (
        <ImageView
          source={url}
          size={size}
          objectPosition='center'
          objectFit={objectFit}
        />
      )
    } else {
      return (
        <VideoView
          source={url}
          size={size}
          controls={false}
        />
      )
    }
  }

  return render()

})

export default PostFormUploadingMediaThumbnail

const useStyles = createUseStyles(theme => ({
  PostFormUploadingMediaThumbnail: {
    position:        'relative',
    backgroundColor: theme.colors.bg.dimmer,
  },

  spinner: {
    ...layout.overlay,
    background: colors.shim.dark,
  },
}))
